import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Separator,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import issueI18n from '@utils/lessonIssueI18n';
import type { ReportedIssueModalProps } from './reported-issue-modal.types';

export const ReportedIssueModal = ({
  tutorName,
  lessonTime,
  lessonDate,
  consumedTickets,
  consumedNoExpirationTickets,
  issueType,
  reportedAt,
  onClose,
}: ReportedIssueModalProps) => {
  const { t } = useTranslation('common');

  return (
    <div className="max-w-xl mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.issue.reported.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onClose}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <div>
            <div className="issue-wrapper">
              <div className="mb-4">
                <h4 className="mb-4">{t('modals.issue.aboutLesson')}</h4>
                <div className="mb-8">
                  <b>{t('general.tutor')}: </b>
                  {tutorName}
                </div>
                <div className="mb-8">
                  <b>{t('general.time')}: </b>
                  {lessonTime}
                </div>
                <div className="mb-8">
                  <b>{t('general.date')}: </b>
                  {lessonDate}
                </div>
                <div className="mb-8">
                  <b>{t('general.consumedTickets')}:</b>{' '}
                  {typeof consumedTickets === 'number'
                    ? t('units.mai', {
                        count: consumedTickets,
                        smart_count: consumedTickets,
                      })
                    : consumedTickets}
                </div>
                <div className="mb-4">
                  <b>{t('general.consumedNoExpirationTickets')}:</b>{' '}
                  {typeof consumedNoExpirationTickets === 'number'
                    ? t('units.mai', {
                        count: consumedNoExpirationTickets,
                        smart_count: consumedNoExpirationTickets,
                      })
                    : consumedNoExpirationTickets}
                </div>
              </div>
              <Separator className="my-4" />
              <h4 className="mb-4">{t('modals.issue.aboutIssue')}</h4>
              <div className="mb-4">
                <b>{t('issue.issueType.title')}:</b>
              </div>
              <div className="mb-8">{issueI18n.type(t, issueType)}</div>
              <div className="mb-4">
                <b>{t('modals.issue.reported.reportedAt')}:</b>
              </div>
              <div className="mb-20">{reportedAt}</div>
              <p>{t('modals.issue.reported.tip')}</p>
            </div>
          </div>
          <Separator className="my-4" />
          <div className="text-right">
            <Button variant="outline" onClick={onClose}>
              {t('links.close')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
